"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = {
            sessions: null,
            more: false,
            fetching: false,
            suggestions: [],
            defaultProvider: null
        };
        this.hasProvider();
        this.fetchSessions();
    },
    onCreateSession: function () {
        window.Extensions.run(this.state.defaultProvider.name, { action: 'open:panel' });
    },
    onOpenSession: function ({__type, __provider, __id}) {
        window.Extensions.run(__provider, {
            body: {
                type: __type,
                id: __id
            }
        });
    },
    onSearchResult: function (results) {
        this.state.suggestions = results.map(({type, topic, description, status}) => {
            return {
                poster: {
                    type: 'image',
                    value: window.Extensions.meta(type).favicon
                },
                title: topic,
                subtitle: description,
                status
            };
        });
    },
    onSearchDismiss: function () {
        this.state.suggestions = [];
    },
    onSelectSuggestion: function (index) {
    },
    fetchSessions: async function () {
        this.state.fetching = true;
        try {
            const {error, message, sessions, more} = await Request(this.state.more || '/livesession/list');
            if (error)
                throw new Error(message);
            if (more) {
                this.state.more = more;
                this.state.sessions = [
                    ...this.state.sessions,
                    ...sessions
                ];
            }
            this.state.sessions = sessions.map(({sessionId, type, provider, topic, description, status, schedules, created, updated}) => {
                console.log(schedules && schedules[0] ? typeof schedules[0].end : '--');
                return {
                    type: type.toCapitalCase(),
                    status,
                    provider: window.Extensions.meta(provider.type).favicon,
                    info: `<b>${ topic }</b><br><p class="mb-0 font-small-4 text-muted">${ description }</p>`,
                    datetime: schedules && schedules.length ? formatDate(schedules[0].start, 'calendar') : `${ formatDate(updated ? updated.at : created.at, 'calendar') }`,
                    __type: type,
                    __provider: provider.type,
                    __id: sessionId
                };
            });
        } catch (error) {
            console.log('Error Fetching Sessions: ', error);
        }
        this.state.fetching = false;
    },
    hasProvider: async function () {
        try {
            const {error, message, results} = await Request(`/extension/search?query=live-session`);
            if (error)
                throw new Error(message);
            if (results && results.length)
                this.state.defaultProvider = results[0];
        } catch (error) {
            console.log('Error Searching Plugin: ', error);
        }
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/LiveSessions/Admin/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    LoadingPage_template = require("../../../components/LoadingPage.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    LoadingPage_tag = marko_loadTag(LoadingPage_template),
    Locale_template = require("../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    WSAdapt_template = require("../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Row_template = require("../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    SearchBar_template = require("../../../../components/SearchBar/index.marko"),
    SearchBar_tag = marko_loadTag(SearchBar_template),
    Bx_template = require("../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Datatable_template = require("../../../components/Datatable/index.marko"),
    Datatable_tag = marko_loadTag(Datatable_template),
    Wrapper_Admin_template = require("../../../components/Wrapper-Admin.marko"),
    Wrapper_Admin_tag = marko_loadTag(Wrapper_Admin_template),
    marko_attrs0 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("77e14a"),
    marko_node0 = marko_createElement("br", null, "7", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "font-medium-2"
      },
    marko_node1 = marko_createElement("br", null, "13", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "btn btn-primary btn-lg m-25"
      },
    marko_node2 = marko_createElement("img", {
        src: "/images/illustration/live-session.png",
        "class": "img-fluid",
        alt: "illustration"
      }, "19", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs3 = {
        "class": "col-12"
      },
    marko_node3 = marko_createElement("br", null, "31", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "32", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "btn btn-secondary btn-icon btn-lg float-right m-25 py-50"
      },
    marko_attrs5 = {
        "class": "btn btn-primary btn-lg float-right m-25"
      };

const tableFormat = [
	{ key: 'provider', label: 'Provider', type: 'image', col: '1' },
	{ key: 'info', label: 'Information' },
	{ key: 'type', label: 'Type', col: '2' },
	{ key: 'status', label: 'Status', col: '2', style: 'text-primary' },
	{ key: 'datetime', label: 'Date & Time', wsadapt: { qs: 'd-none', hs: 'd-none' } }
];

function render(input, out, __component, component, state) {
  var data = input;

  Wrapper_Admin_tag({
      renderBody: function(out, { page }) {
        if (state.sessions === null) {
          LoadingPage_tag({}, out, __component, "1");
        } else if (!state.sessions.length) {
          out.be("div", marko_attrs0, "2", component);

          Row_tag({
              class: "m-0 w-100 d-flex align-items-center",
              renderBody: function(out) {
                WSAdapt_tag({
                    class: "col",
                    renderBody: function(out) {
                      out.be("h5", null, "5", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Add & Manage Live Sessions");
                          }
                        }, out, __component, "6");

                      out.ee();

                      out.n(marko_node0, component);

                      out.be("p", marko_attrs1, "8", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Today, we're more closer with live sessions. Here, you can manage your meetings, events, live classes at your ease. Add your favorate live session providers from our");
                          }
                        }, out, __component, "9");

                      out.t(" ");

                      route_link_tag({
                          href: "/marketplace/#plugins/live-session",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Marketplace"
                              }, out, __component, "11");
                          }
                        }, out, __component, "10");

                      out.t(" ");

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("and there you go.");
                          }
                        }, out, __component, "12");

                      out.ee();

                      out.n(marko_node1, component);

                      if (state.defaultProvider) {
                        out.be("button", marko_attrs2, "14", component, null, 0, {
                            onclick: __component.d("click", "onCreateSession", false)
                          });

                        Locale_tag({
                            text: "Create Session"
                          }, out, __component, "15");

                        out.ee();
                      }

                      route_link_tag({
                          class: ("btn btn-" + (!state.defaultProvider ? "primary" : "secondary")) + " btn-lg m-25",
                          href: "/session-providers",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Manage Providers"
                              }, out, __component, "17");
                          }
                        }, out, __component, "16");
                    }
                  }, out, __component, "4");

                WSAdapt_tag({
                    class: "col text-center",
                    renderBody: function(out) {
                      out.n(marko_node2, component);
                    }
                  }, out, __component, "18");
              }
            }, out, __component, "3");

          out.ee();
        } else {
          Row_tag({
              class: "m-0",
              renderBody: function(out) {
                WSAdapt_tag({
                    ns: "col-md-5 col-12",
                    qs: "col-7",
                    hs: "col-7",
                    renderBody: function(out) {
                      SearchBar_tag({
                          icon: "bx-search",
                          target: "live-session",
                          minLength: 3,
                          suggestions: state.suggestions,
                          placeholder: Locale("Find a Session")
                        }, out, __component, "22", [
                        [
                          "blur",
                          "onSearchDismiss",
                          false
                        ],
                        [
                          "result",
                          "onSearchResult",
                          false
                        ],
                        [
                          "select",
                          "onSelectSuggestion",
                          false
                        ]
                      ]);
                    }
                  }, out, __component, "21");

                WSAdapt_tag({
                    class: "col",
                    renderBody: function(out) {
                      out.be("button", marko_attrs4, "24", component, null, 0, {
                          onclick: __component.d("click", "fetchSessions", false)
                        });

                      Bx_tag({
                          type: "refresh",
                          class: marko_classValue([
                            "font-large-1 white-text",
                            state.fetching ? "bx-spin" : false
                          ])
                        }, out, __component, "25");

                      out.ee();

                      route_link_tag({
                          href: "/session-providers",
                          class: "btn btn-secondary btn-lg float-right m-25",
                          renderBody: function(out) {
                            Locale_tag({
                                text: "Manage Providers"
                              }, out, __component, "27");
                          }
                        }, out, __component, "26");

                      out.be("button", marko_attrs5, "28", component, null, 0, {
                          onclick: __component.d("click", "onCreateSession", false)
                        });

                      Locale_tag({
                          text: "Create Session"
                        }, out, __component, "29");

                      out.ee();
                    }
                  }, out, __component, "23");

                out.be("div", marko_attrs3, "30", component);

                out.n(marko_node3, component);

                out.n(marko_node4, component);

                Datatable_tag({
                    format: tableFormat,
                    data: state.sessions,
                    pagination: 10,
                    stripped: true,
                    loading: state.fetching,
                    class: "w-100 theme-bg"
                  }, out, __component, "33", [
                  [
                    "canload",
                    "fetchSessions",
                    false
                  ],
                  [
                    "select",
                    "onOpenSession",
                    false
                  ]
                ]);

                out.ee();
              }
            }, out, __component, "20");
        }
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
